import { GET_ADMINS, GET_ADMINS_SUCCESS, GET_ADMINS_ERROR, GET_ADMIN_INFO, GET_ADMIN_INFO_SUCCESS, API_ERROR } from "./actionTypes"
const initialState = { admins: {}, adminInfo: {}, loading: false, error: "", listLoading: false, listError: "" }
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMINS: return { ...state, listLoading: true, listError: "" }
    case GET_ADMINS_SUCCESS: return { ...state, listLoading: false, listError: "", admins: action.payload }
    case GET_ADMINS_ERROR: return { ...state, listLoading: false, listError: "Could not load admins. Please try again." }
    case GET_ADMIN_INFO: return { ...state, loading: true, error: "", adminInfo: {} }
    case GET_ADMIN_INFO_SUCCESS: return { ...state, loading: false, error: "", adminInfo: action.payload }
    case API_ERROR: return { ...state, loading: false, error: action.payload }
    default: return state
  }
}
